import React from 'react';
import { Hero } from '../components/Hero';
import { ProofBar } from '../components/ProofBar';
import { PainSection } from '../components/PainSection';
import { MistrBrain } from '../components/MistrBrain';
import { ChannelCards } from '../components/ChannelCards';
import { AskAnything } from '../components/AskAnything';
import { BuiltDifferent } from '../components/BuiltDifferent';
import { HowItWorks } from '../components/HowItWorks';
import { FeaturesGrid } from '../components/FeaturesGrid';
import { StorySection } from '../components/StorySection';
import { IntegrationsPreview } from '../components/IntegrationsPreview';
import { Pricing } from '../components/Pricing';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <main data-id="element-1712">
      <Hero data-id="element-1713" />
      <ProofBar data-id="element-1714" />
      <PainSection data-id="element-1715" />
      <MistrBrain data-id="element-1716" />
      <ChannelCards data-id="element-1717" />
      <AskAnything data-id="element-1718" />
      <BuiltDifferent data-id="element-1719" />
      <HowItWorks data-id="element-1720" />
      <FeaturesGrid data-id="element-1721" />
      <StorySection data-id="element-1722" />
      <IntegrationsPreview data-id="element-1723" />
      <Pricing data-id="element-1724" />
      <FinalCTA data-id="element-1725" />
    </main>;
}